const createQuery = () => `
  ... on CompanyPortalBannerWidget {
    id
    title
    subtitle
    images {
      desktop_background_720 {
        url
      }
      desktop_background_1440 {
        url
      }
      mobile_background_320 {
        url
      }
      mobile_background_640 {
        url
      }
    }
  }
`

export default createQuery
